import styled from 'styled-components';

export const Title = styled.p`
  font-weight: bold;
  margin-bottom: 16px;
`;
